import React, { Component } from "react";
import PropTypes from "prop-types";
import CustomPropTypes from "../utils/customPropTypes";
import ImageBlock from "../components/ImageBlock";
import style from "../../scss/components/GenericDocument";
import ButtonLink from './ButtonLink';
import { Transition } from 'semantic-ui-react'
import GenericCarousel from "./GenericCarousel";

export default class GenericDocument extends Component {
    static ControlTypes = {
        Default: "",
        Accessories: "accessories"
    };
    
    static defaultProps = {
        controlType: GenericDocument.ControlTypes.Default
    };
    
    static propTypes = {
        title: PropTypes.string,
        description: PropTypes.string,
        cards: PropTypes.arrayOf(
            PropTypes.shape({
                eyebrow: PropTypes.string,
                link: CustomPropTypes.Link,
                icon: CustomPropTypes.Image,
                title: PropTypes.string,
                document_title: PropTypes.string,
                url: PropTypes.string
            })
        ),
        controlType: PropTypes.string
    };

    constructor(props) {
        super(props);
        this.state = {
            isPopupOpen: false,
            videoUrl: '',
            videos: []
        };
        this.ItemToShow = 6;
    }

    componentDidMount() {
        this.setState({ videos: this.props.cards.slice(0, this.ItemToShow) });
    }

    getType = (objVideo) => {
        return objVideo.url && objVideo.url.toLowerCase().includes("youtube");
    }

    // Convert YouTube URL to embed URL
    getEmbedUrl = (url) => {
        const videoId = url.split('v=')[1];
        if (videoId) {
            return `https://www.youtube.com/embed/${videoId}?autoplay=1&modestbranding=1`;
        }
        return url;
    }

    openPopup = (objVideo) => {
        if (this.getType(objVideo)) {
            this.setState({ 
                isPopupOpen: true,
                videoUrl: this.getEmbedUrl(objVideo.url)
            });
        } else {
            window.open(objVideo.url);
        }
    }

    closePopup = () => {
        this.setState({ 
            isPopupOpen: false,
            videoUrl: ''
        });
    }

    getVideoPopup = () => {
        const { isPopupOpen, videoUrl } = this.state;
        
        if (!isPopupOpen) return null;

        return (
            <div className="video-popup" onClick={this.closePopup}>
                <div className="popup-content">
                    <div className="video-container">
                        <iframe
                            title="Video Popup"
                            width="560"
                            height="315"
                            src={videoUrl}
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        ></iframe>
                    </div>
                </div>
                <b className="close-btn"><span className="close-btn-span">×</span></b>
            </div>
        );
    }

    getVideoCardList = () => {
        let items = this.state.videos;
        if (!items || items.length === 0) return null;

        return (
            <Transition.Group duration={500} animation="fade">
                {items.map((objItem, index) => {
                    // Extract YouTube video ID for thumbnail
                    const youtubeId = objItem.url.split('v=')[1];
                    const thumbnailURL = youtubeId ? `https://img.youtube.com/vi/${youtubeId}/0.jpg` : null;

                    return (
                        <div key={index} className="video-grid-item">
                            <a onClick={() => this.openPopup(objItem)} className="video-card">
                                <div className="video-card-inner">
                                    <div className={`video-card-preview ${this.getType(objItem) ? 'type-video' : 'type-doc'}`}>
                                        {this.getType(objItem) ? (
                                            <>
                                                <svg className="video-play-icon" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100" viewBox="0 0 48 48">
                                                    <path fill="#FF3D00" d="M43.2,33.9c-0.4,2.1-2.1,3.7-4.2,4c-3.3,0.5-8.8,1.1-15,1.1c-6.1,0-11.6-0.6-15-1.1c-2.1-0.3-3.8-1.9-4.2-4C4.4,31.6,4,28.2,4,24c0-4.2,0.4-7.6,0.8-9.9c0.4-2.1,2.1-3.7,4.2-4C12.3,9.6,17.8,9,24,9c6.2,0,11.6,0.6,15,1.1c2.1,0.3,3.8,1.9,4.2,4c0.4,2.3,0.9,5.7,0.9,9.9C44,28.2,43.6,31.6,43.2,33.9z"></path>
                                                    <path fill="#FFF" d="M20 31L20 17 32 24z"></path>
                                                </svg>
                                                {thumbnailURL && <img defer src={thumbnailURL} alt="Video Thumbnail" />}
                                            </>
                                        ) : (
                                            <>
                                                <div className="custom-eyebrow">{objItem.eyebrow}</div>
                                                <div className="custom-content">
                                                    {objItem.document_title}
                                                </div>
                                                <div className="custom-card-action">
                                                    <i className="icon icon-direction-right"></i>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </a>
                        </div>
                    );
                })}
            </Transition.Group>
        );
    }

    handleLoadMore = () => {
        this.setState((prev) => ({
            videos: this.props.cards.slice(0, prev.videos.length + this.ItemToShow)
        }));
    }

    render() {
        const str = window.location.href;
        let load_more, title;
        
        if (str.includes("/es/")) {
            load_more = 'Cargar más';
            title = 'Información Relacionada';
        }
        if (str.includes("/en/") || str.includes("/en-uk/")) {
            load_more = 'Load more';
            title = 'Related Information';
        }

        return (
            <div className="video-grid-section">
                <div className="container">
                    <h3>{title}</h3>
                    <div className="video-grid">
                        {this.getVideoPopup()}
                        <div className="video-grid-items">
                            {this.getVideoCardList()}
                        </div>
                        {this.props.cards && 
                         this.state.videos && 
                         this.state.videos.length < this.props.cards.length && 
                         <></>
                        }
                    </div>
                </div>
            </div>
        );
    }
}